var map = {
	"./store-amazon.svg": "d777",
	"./store-aspdotnetstorefront.svg": "f78a",
	"./store-bigcommerce.svg": "fdb0",
	"./store-commercehq.svg": "5ef2",
	"./store-demandware.svg": "07c0",
	"./store-ebay.svg": "a660",
	"./store-ecwid.svg": "c21f",
	"./store-etsy.svg": "8bc3",
	"./store-hybris.svg": "a062",
	"./store-lightspeed.svg": "e0fa",
	"./store-mssql.svg": "bab0",
	"./store-neto.svg": "f2c0",
	"./store-restapi.svg": "9b9a",
	"./store-shopify.svg": "ab4b",
	"./store-shopware.svg": "593c",
	"./store-sqlserver.svg": "0e16",
	"./store-squarespace.svg": "9eb7",
	"./store-threedcart.svg": "78fd",
	"./store-volusion.svg": "4dd4",
	"./store-walmart.svg": "6081",
	"./store-woocommerce.svg": "6e94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2df6";